import {easeInCubic} from 'modules/ease.js';

export default function () {

    return easeInCubic;
};
